module.exports = __webpack_public_path__ + "static/media/new_rieltor_bonus_desktop_x1.ba8ccc09.png";